import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { WarningBadge, StatusBadge } from "@/components/Badges";
import { FileStack } from "lucide-react";

export default function MyReports() {
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get("/reports/mine").then((r) => setRows(r.data)).finally(() => setLoading(false));
  }, []);

  return (
    <div>
      <h1 className="font-display text-4xl sm:text-5xl font-black tracking-tighter text-white flex items-center gap-3">
        <FileStack className="w-9 h-9 text-primary" /> Báo cáo của tôi
      </h1>
      <p className="text-zinc-500 mt-2 mb-6">Toàn bộ báo cáo bạn đã gửi và trạng thái duyệt.</p>

      {loading ? (
        <p className="text-zinc-600 py-10 text-center">Đang tải...</p>
      ) : rows.length === 0 ? (
        <p className="text-zinc-600 py-10 text-center">Bạn chưa gửi báo cáo nào.</p>
      ) : (
        <div className="space-y-3">
          {rows.map((r) => (
            <div key={r.id} data-testid={`myreport-${r.id}`} className="bg-card border border-zinc-800 rounded-sm p-4">
              <div className="flex flex-wrap items-center justify-between gap-2 mb-2">
                <div className="font-semibold text-white">{r.customer_name}</div>
                <div className="flex items-center gap-2">
                  <WarningBadge level={r.warning_level} />
                  <StatusBadge status={r.status} />
                </div>
              </div>
              <div className="text-sm text-zinc-500">
                CCCD: {r.cccd_number || "—"} · SĐT: {r.phone || "—"} · {new Date(r.report_date).toLocaleDateString("vi-VN")}
              </div>
              <p className="text-sm text-zinc-400 mt-2">{r.reason}</p>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
